<template>
      <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #9C1A1A">{{ tipo === 'editar' ? 'Editar Universidad' : tipo === 'crear' ? 'Crear Universidad' : 'Ficha de la Universidad' }}</span></h3>
          </v-card-title>
          <v-card-text>



                        <v-text-field
                            :disabled="tipo === 'ver'"
                            ref="code"
                            prepend-icon="code"
                            v-model="form.code"
                            :rules="[v => !!v || 'Las SIGLAS de la Universidad es requerida']"
                            :error-messages="errName"
                            label="Siglas"
                            required
                            ></v-text-field>

                        <v-text-field
                            :disabled="tipo === 'ver'"
                            ref="name"
                            prepend-icon="location_city"
                            v-model="form.name"
                            :rules="[v => !!v || 'El nombre es requerido']"
                            :error-messages="errName"
                            label="Nombre"
                            required
                            ></v-text-field>
                <!-- <v-flex xs12 align-center justify-space-between>
                    <v-layout align-center>

                    </v-layout>
                </v-flex> -->
          </v-card-text>
          <v-card-actions>
            <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="tipo !== 'ver'" :loading="loading" class="primary" @click="submit">{{ tipo === 'editar' ? 'Actualizar' : tipo === 'crear' ? 'Crear': 'Ver' }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'

export default {
  name: 'form-university-view',

  props: {
    tipo: {
      type: String,
      required: true
    },
    datos: {
      type: Object,
      required: true
    }
  },

  watch: {
    datos(v) {
      this.$refs.form.resetValidation()
      if (this.tipo == "crear") {
        Object.assign(this.form, this.formOld)
      }else {
        Object.assign(this.form, v)
        // if(v.unionize != null) {
        //   this.form.cpc = v.unionize.cpc
        //   this.form.title = v.unionize.title
        // }
      }
    }
  },

  data: () => ({
    errName: [],
    valid: false,
    loading: false,
    form: new Form({
        name: ''
    }),
    formOld:{
        name: ''
    }
  }),

  mounted() {
    this.$store.dispatch('clearMessage')
  },

  methods: {

    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.submitFormUniversities()
      }
    },

    async submitFormUniversities () {
      try {
        if (this.tipo == 'crear') {
          const { data } = await axios.post('/api/universities/admin/create_university', this.form)
          this.cerrarDialog(data)
        }else {
          const { data } = await axios.patch('/api/universities/admin/update_university', this.form)
          this.cerrarDialog(data)
        }
      } catch (e) {
        console.log(e.response, 'data error create')
        this.loading = false
        if (e.response.data.errors) {
          this.form.errors.errors = e.response.data.errors
          if (e.response.data.errors.code) {
            this.$refs.code.focus()
            //this.errName.push('name ya existe')
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.code[0]
            })
          }
        }else {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: e.response.data.error
          })
        }
      }

    },

    cerrarDialog (data) {
      this.$emit('closeDialogUniversity', data)
      this.$nextTick(() => {
        //this.errTit = []
        this.$refs.form.resetValidation()
        this.loading = false
     })
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/formUniversities.vue